<!-- <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
  <div class="text-center">
    <p class="text-base font-semibold text-indigo-600">404</p>
    <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">¡UH OH! Estás perdido.</h1>
    <p class="mt-6 text-base leading-7 text-gray-600">La página que buscas no existe. Cómo llegaste aquí es un misterio.</p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <a href="sadi/upload" class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Go back home</a>
      <a href="#" class="text-sm font-semibold text-gray-900">Contact support <span aria-hidden="true">&rarr;</span></a>
    </div>
  </div>
</main> -->


<section class="bg-white dark:bg-gray-900 ">
  <div class="container min-h-screen px-6 py-12 mx-auto lg:flex lg:items-center lg:gap-12">
      <div class="wf-ull lg:w-1/2">
          <p class="text-sm font-medium text-[#0a8342] dark:text-[#0a8342]">404 error</p>
          <h1 class="mt-3 text-2xl font-semibold text-gray-800 dark:text-white md:text-3xl">Page not found</h1>
          <p class="mt-4 text-gray-500 dark:text-gray-400">Sorry, the page you are looking for doesn't exist.Here are some helpful links:</p>

          <div class="flex items-center mt-6 gap-x-3">

              <button (click)="goBack()" class="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:rotate-180">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                  </svg>
                  <span>Go back</span>
              </button>

              <button routerLink="/sadi/upload" class="w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 bg-[#0a8342] rounded-lg shrink-0 sm:w-auto hover:bg-[#03531d] dark:hover:bg-[#03531d] dark:bg-[#0a8342]">
                  Take me home
              </button>
          </div>
      </div>

      <div class="relative w-full mt-12 lg:w-1/2 lg:mt-0">
          <img class="w-full max-w-lg lg:mx-auto" src="/assets/images/404.svg" alt="">
      </div>
  </div>
</section>
